/**
 * This module contains validators used by redux-form fields.
 */
import getPasswordStrength from './../../../../utilities/passwordStrength';

export const required = value => (value ? undefined : 'Required');

export const validEmail = (value) => {
  if (value.includes('@')) {
    const split = value.split('@');
    if (split[1].trim() !== '' && split[1].trim().length !== 0) {
      if (split[1].includes('.')) {
        const checkAfterDot = split[1].split('.');
        if (checkAfterDot[1].trim() !== '' && checkAfterDot[1].trim().length !== 0) {
          return undefined;
        }
        return `'.' is used at the wrong position in '${split[1]}'`;
      }
      return 'Email must contain a \'.\' after the \'@\'';
    }
    return 'Email must not be blank after the \'@\'';
  }
  return 'Email must contain \'@\'';
};

export const validPassword = (value) => {
  const isValid = getPasswordStrength(value).strength === 3;
  if (isValid) {
    return undefined;
  }

  return 'password strength';
};
